<div class="progressbar" role="group">
  <div class="progressbar__track" role="progressbar" [attr.aria-valuenow]="total$()">
    @for (segment of normalizedSegments$(); track $index) {
      <div
        class="progressbar__segment"
        [class]="segment.color"
        [style.width.%]="segment.value"
        [matTooltip]="segment.label"
        [attr.aria-label]="segment.label ?? null"
      ></div>
    }
  </div>

  <span class="fs__sm fw__500">{{ total$() }}%</span>
</div>
